var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main jc-center"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("合作伙伴")]),_vm._v(" "),_c('div',{staticClass:"flex wrap"},_vm._l((_vm.list),function(item,index){return _c('img',{key:index,attrs:{"src":item.picture}})}),0)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ff30398","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/designPage/template/other/other2/index.vue
// module id = null
// module chunks = 